import { render, staticRenderFns } from "./product_classify.vue?vue&type=template&id=280a9de1&"
import script from "./product_classify.vue?vue&type=script&lang=js&"
export * from "./product_classify.vue?vue&type=script&lang=js&"
import style0 from "./product_classify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VCard,VImg})
